const INSTRUCTION_COVER_KEYS = [
  'cover_url',
  'poster_url',
  'image_url',
  'thumbnail_url'
] as const

export function pickCoverFromInstruction(instruction: unknown): string | null {
  let value: unknown = instruction
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed) {
      return null
    }
    try {
      value = JSON.parse(trimmed) as unknown
    } catch {
      return null
    }
  }
  if (!value || typeof value !== 'object') {
    return null
  }
  const o = value as Record<string, unknown>
  for (const k of INSTRUCTION_COVER_KEYS) {
    const v = o[k]
    if (typeof v === 'string' && v.trim().length > 0) {
      return v.trim()
    }
  }
  return null
}

export function pickTaskCoverUrl(options: {
  thumbnailUrl?: string | null | undefined
  instruction?: unknown
  preferThumbnail?: boolean
}): string | null {
  const raw =
    typeof options.thumbnailUrl === 'string' ? options.thumbnailUrl.trim() : ''
  if (options.preferThumbnail && raw) {
    return raw
  }
  const fromInstruction = pickCoverFromInstruction(options.instruction)
  if (fromInstruction) {
    return fromInstruction
  }
  return raw.length > 0 ? raw : null
}
